import React from "react";
import { Grid, Button, Paper, InputLabel, Select, Input, MenuItem, Link } from "@material-ui/core";
import { Launch as ExternalLinkIcon } from '@material-ui/icons';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { ThemeProvider } from "@material-ui/styles";
import DateFnsUtils from "@date-io/date-fns";
import MUIDataTable from "mui-datatables";
// import queryString from 'query-string'

//style
import Themes from "../../themes";
import useStyles from "./styles";

//our components
import PageError from '../../components/PageError';
import PageLoading from '../../components/PageLoading';
import Drawer from '../../components/DrawerDefault';
import GridByDay from '../../components/GridByDay/gridByDay';
import PublisherChart from "../../components/Charts/publisher";
import GeneralIndicators from "../../components/Indicators/General/general";
import { isAdmCheck } from "../../components/Validations/isAdmCheck";
import { filterOptionsArray } from "../../components/Utils/filters";
import { formatImp, formatRevenue, momentFormat } from "../../components/Utils/formatters";
import { moment } from "../../components/Utils/momentConfig";
import { Typography } from "../../components/Wrappers";

//queries
import { useQuery } from '@apollo/react-hooks';
import { GET_REPORT_BY_PUBLISHER } from "../../queries/reports";
import { GET as GET_NETWORK } from "../../queries/network";
import { GET_BY_NETWORK } from "../../queries/networkSite";
import { GET_NETWORK_BY_USER } from "../../queries/userNetworks";
import { GET_PAGEVIEWS_BY_DATE } from "../../queries/analyticsReport";
import { GET } from "../../queries/site";

let mainTableData = [];
let loading = undefined;
let error = undefined;
let pageViewsTotal = 0;
let ctrTotal = 0;
let impressionsTotal = 0;
let revenueTotal = 0;
let viewabilityTotal = 0;
let total = 0;
let totalActive = 0;
let networks = [];
let publishersByNetwork = [];

export default function ReportByPublisher(props) {
  var classes = useStyles();

  // const filters = queryString.parse(props.location.search);
  let initialDateValue = moment().subtract(7, 'days').format(momentFormat);
  let endDateValue = moment().subtract(1, 'days').format(momentFormat);
  let publisherIdValue = "";

  const [networkPublishers, setNetworkPublishers] = React.useState([""]);
  const [network, setNetwork] = React.useState("");
  const handleNetworkChange = network => {
    setNetwork(network.target.value);
    setNetworkPublishers([]);
    publishersByNetwork = [];
    setPublisherId("");
    setSiteId("");
  };

  const [dateTypeFilter, setDateTypeFilter] = React.useState("Last7Days");
  const handleDateTypeChange = value => {
    const myButtonType = value && value.target ? value.target.value : "";
    setDateTypeFilter(myButtonType);
    if (myButtonType === "ThisMonth") {
      const initialDate = moment().add(1, 'days').startOf('month').format(momentFormat);
      const endDate = moment().add(1, 'days').endOf('month').format(momentFormat);
      setInitialDate(moment(initialDate));
      setEndDate(moment(endDate));
    }
    else if (myButtonType === "LastMonth") {
      const initialDate = moment().subtract(1, 'month').startOf('month').format(momentFormat);
      const endDate = moment().subtract(1, 'month').endOf('month').format(momentFormat);
      setInitialDate(moment(initialDate));
      setEndDate(moment(endDate));
    }
    else
    {
      var option = filterOptionsArray.filter((dateType) => 
      { 
        return dateType.id === myButtonType; 
      });
      if(option && option[0])
      {
        setInitialDateHelper(option[0].initialValueCalc);
        setEndDateHelper(option[0].endValueCalc);
      }
    }
  }

  const [tileView, setTileView] = React.useState(true);
  const [initialDate, setInitialDate] = React.useState(initialDateValue);
  const [endDate, setEndDate] = React.useState(endDateValue);
  const [publisherId, setPublisherId] = React.useState(publisherIdValue);
  const [siteId, setSiteId] = React.useState("");
  const handleInitialDateChange = date => { setInitialDate(date); };
  const handleEndateChange = date => { setEndDate(date); };

  function getHeaderLabel(index, column, sortColumn, value) {
    return (
      <>
        <th className={classes.headerSum} onClick={() => sortColumn(index)} key={index}>
          {column.name} <br /> {value}
        </th>
      </>
    )
  }

  const setInitialDateHelper = addDaysValue => {
    const date = moment().add(addDaysValue, 'days');
    const returnDate = moment(date).format(momentFormat)
    setInitialDate(returnDate);
    return returnDate;
  };

  const setEndDateHelper = addDaysValue => {
    const date = moment().add(addDaysValue, 'days');
    const returnDate = moment(date).format(momentFormat)
    setEndDate(returnDate);
    return returnDate;
  };

  let updatedData = [];
  const isAdm = isAdmCheck();
  let dataNetwork = undefined;

  const { data } = useQuery(GET_REPORT_BY_PUBLISHER, {
    variables: { dateStart: moment(initialDate).format(momentFormat), dateEnd: moment(endDate).format(momentFormat) },
  });

  const { data: dataNetworkFilter } = useQuery(GET_NETWORK_BY_USER, {
    variables: { user: localStorage.getItem("id_user") },
  });
  let { data: dataAccessNetwork } = useQuery(GET_BY_NETWORK, {
    variables: { network: network },
  });
  let { data: dataAnalyticsPageViews } = useQuery(GET_PAGEVIEWS_BY_DATE, {
    variables: { dateStart: moment(initialDate).format(momentFormat), dateEnd: moment(endDate).format(momentFormat) },
  });

  const { data: dataPublisher } = useQuery(GET);
  const { data: dataNetworkAll } = useQuery(GET_NETWORK);

  if (data && dataPublisher && dataNetworkAll && dataNetworkFilter && dataAccessNetwork && dataAnalyticsPageViews) {
    if (isAdm) {
      dataNetwork = dataNetworkAll;
      if (dataNetwork.networks)
        networks = dataNetwork.networks;
      if (network === "") {
        setNetwork("all");
        setNetworkPublishers([]);
      }
    }
    else {
      dataNetwork = dataNetworkFilter;
      if (dataNetwork.userNetworks)
        networks = dataNetwork.userNetworks;
    }

    if (dataNetwork.networks)
      networks = dataNetwork.networks;

    //Filter network to indicators
    if (network === "all") {
      const sites = dataPublisher.sites;
      sites.forEach(site => {
        if (site && site.publisherId && !publishersByNetwork.includes(site.publisherId))
          publishersByNetwork.push(site.publisherId);
      });
      dataAccessNetwork = undefined;
    }
    else
      if (dataAccessNetwork && dataAccessNetwork.networkSites) {
        publishersByNetwork.splice(0,publishersByNetwork.length);
        dataAccessNetwork.networkSites.forEach(networkSite => {
          if (networkSite && networkSite.site)
            publishersByNetwork.push(networkSite.site.publisherId);
        });
      }

    if (data.reportByPublisherByRangeDate) {
      const sites = dataPublisher.sites;
      const pageViews = dataAnalyticsPageViews.pageViewByRangeDate;
      data.reportByPublisherByRangeDate.forEach(row => {
        if (dataAccessNetwork &&
          dataAccessNetwork.networkSites) {
          //Filter network on grid
          dataAccessNetwork.networkSites.forEach(networkSite => {
            if (networkSite && networkSite.site &&
              networkSite.site.publisherId === row.publisherId) {
              if(!publishersByNetwork.includes(networkSite.site.publisherId))
                publishersByNetwork.push(networkSite.site.publisherId);
              filterData(sites, pageViews, row);
            }
          });
        }
        else
          filterData(sites, pageViews, row);

      });
    }

    updatedData.sort((a, b) => (a.publisherName > b.publisherName) ? 1 : ((b.publisherName > a.publisherName) ? -1 : 0));
    mainTableData = updatedData;

    pageViewsTotal = 0;
    ctrTotal = 0;
    impressionsTotal = 0;
    revenueTotal = 0;
    viewabilityTotal = 0;
    total = 0;
    totalActive = 0;
    mainTableData.forEach((row) => {
      total++;
      if(row.impressions !== 0)
        totalActive++;
      pageViewsTotal += parseFloat(row.pageViews ? row.pageViews : 0);
      ctrTotal += parseFloat(row.ctr ? row.ctr : 0);
      impressionsTotal += parseFloat(row.impressions ? row.impressions : 0);
      revenueTotal += parseFloat(row.revenue ? row.revenue : 0);
      viewabilityTotal += parseFloat(row.viewability && row.viewability > 0 ? row.viewability : 0);
    });

    function filterData(sites, pageViews, row) {
      var filteredSite = sites.filter((site) => {
        return site.publisherId === row.publisherId;
      });
      const newRow = row;
      if (filteredSite && filteredSite[0]) {
        const pageViewsRow = pageViews.filter((p) => { return p.siteId === filteredSite[0].id });
        newRow.publisherName = filteredSite[0].name;
        newRow.siteId = filteredSite[0].id;
        newRow.domain = filteredSite[0].domain;
        if (pageViewsRow && pageViewsRow[0] && pageViewsRow[0].pageViews)
          newRow.pageViews = pageViewsRow[0].pageViews;
      }
      //if(newRow.publisherName)
      updatedData.push(newRow);
    }
  }

  if (publishersByNetwork && publishersByNetwork.length > 0 && networkPublishers !== publishersByNetwork) {
    setNetworkPublishers(publishersByNetwork);
  }

  return (
    <>
      <ThemeProvider theme={Themes.defaultReports}>
        <Grid container spacing={1}>
          <Grid item xs={tileView ? 8 : 4}>
            <Typography variant="h3" style={{ marginBottom: '9px' }}>Report by Publisher</Typography>
            {(tileView ?
              <Button color="primary" variant="contained" style={{ width: '50%' }} onClick={() => { setTileView(false) }}>
                GRID VIEW
          </Button> :
              <Button color="primary" variant="contained" style={{ width: '50%' }} onClick={() => { setTileView(true) }}>
                TILE VIEW
          </Button>)}
          </Grid>
          <Grid item xs={tileView ? 4 : 8}>
            <Paper className={classes.paper}>
              <div className={classes.root}>
                <Grid container spacing={1}>
                {(!tileView ?
                <>
                  <Grid item xs={3}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <InputLabel className={classes.marginText}>Initial Date</InputLabel>
                      <KeyboardDatePicker disableToolbar variant="inline" format="yyyy-MM-dd" margin="normal" id="date-picker-inline1" style={{ width: '100%' }}
                        value={moment(initialDate)} onChange={handleInitialDateChange} KeyboardButtonProps={{ "aria-label": "change date" }} className={classes.marginDefault}
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item xs={3}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <InputLabel className={classes.marginText}>End Date</InputLabel>
                      <KeyboardDatePicker disableToolbar variant="inline" format="yyyy-MM-dd" margin="normal" id="date-picker-inline2" style={{ width: '100%' }}
                        value={moment(endDate)} onChange={handleEndateChange} KeyboardButtonProps={{ "aria-label": "change date" }} className={classes.marginDefault}
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  
                  <Grid item xs={3}>
                    <InputLabel className={classes.marginText}>Date Types</InputLabel>
                    <Select
                      id="dateTypeFilter-lookup-id"
                      label="Date Helper"
                      value={dateTypeFilter}
                      onChange={handleDateTypeChange}
                      input={<Input />}
                      className={classes.marginDefault}
                      style={{ width: '100%' }}
                    >
                      {filterOptionsArray.map(item => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>))
                      }
                    </Select>
                  </Grid></> : <></>)}
                  <Grid item xs={tileView ? 12 : 3}>
                    <InputLabel className={classes.marginText}>Networks</InputLabel>
                    <Select
                      id="network-lookup-id"
                      value={network}
                      onChange={handleNetworkChange}
                      input={<Input />}
                      className={classes.marginDefault}
                      style={{ width: '90%' }}
                    >
                      {(isAdmCheck() ?
                        <MenuItem key="all" value="all" selected>
                          All
                </MenuItem> : <></>)}
                      {(isAdmCheck()) ?
                        networks.map(item => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        )) :
                        networks.map(item => (
                          <MenuItem key={item.network.id} value={item.network.id}>
                            {item.network.name}
                          </MenuItem>
                        ))
                      }
                    </Select>
                  </Grid>
                </Grid>
              </div>
            </Paper>

          </Grid>
        </Grid>
        <br />
        {(tileView ? <GeneralIndicators publishers={networkPublishers} siteId={siteId} showAdunits={false} isDashboard={false}></GeneralIndicators> :
          <>
            <Grid container spacing={4}>
              <br />
              <PublisherChart isDashboard={false} initialDate={initialDate} endDate={endDate} networkPublishers={networkPublishers}></PublisherChart>
              <Grid item xs={12}>
                {(loading) ? <PageLoading /> :
                  (error) ? <PageError /> :
                    (
                      <Grid container spacing={4}>
                        <Grid item xs={12}>
                          <MUIDataTable
                            title={false}
                            data={mainTableData}
                            columns={[
                              {
                                name: "publisherId",
                                options: {
                                  display: false
                                }
                              },
                              {
                                name: 'publisherName',
                                options: {
                                  customHeadRender: ({ index, ...column }, sortColumn) => {
                                    return getHeaderLabel(index, column, sortColumn, `Total: ${total} Active: ${totalActive}`)
                                  },
                                  customBodyRender: (value, tableMeta, updateValue) => {
                                    const myRow = tableMeta.rowData;
                                    const publisherId = myRow[0];
                                    const publisherName = myRow[1];
                                    const siteId = myRow[2];
                                    const domain = myRow[3];
                                    return (
                                      <>
                                        <Drawer title={publisherName} iconButtonAction={false} labeButtonAction={publisherName}>
                                          <GridByDay initialDate={initialDate} endDate={endDate}
                                            publisherId={publisherId} siteId={siteId}
                                            networkPublishers={[publisherId]} network={""}></GridByDay>
                                        </Drawer>&nbsp;
                                        <Link href={`https://${domain}`} target="_blank" rel="noreferrer">
                                          <ExternalLinkIcon fontSize="small" />
                                        </Link>
                                      </>
                                    );
                                  }
                                }
                              },
                              {
                                name: "siteId",
                                options: {
                                  display: false
                                }
                              },
                              {
                                name: "domain",
                                options: {
                                  display: false
                                }
                              },
                              {
                                name: 'pageViews',
                                options: {
                                  customHeadRender: ({ index, ...column }, sortColumn) => {
                                    return getHeaderLabel(index, column, sortColumn, formatImp(pageViewsTotal))
                                  },
                                  customBodyRender: (value) => {
                                    return (formatImp(value));
                                  }
                                }
                              },
                              {
                                name: 'ctr',
                                options: {
                                  customHeadRender: ({ index, ...column }, sortColumn) => {
                                    return getHeaderLabel(index, column, sortColumn, (ctrTotal / total).toFixed(2))
                                  },
                                }
                              },
                              {
                                name: 'cpm',
                                options: {
                                  customHeadRender: ({ index, ...column }, sortColumn) => {
                                    return getHeaderLabel(index, column, sortColumn, ((revenueTotal / impressionsTotal)).toFixed(2))
                                  },
                                }
                              },
                              {
                                name: 'impressions',
                                options: {
                                  customHeadRender: ({ index, ...column }, sortColumn) => {
                                    return getHeaderLabel(index, column, sortColumn, formatImp(impressionsTotal))
                                  },
                                  customBodyRender: (value) => {
                                    return (formatImp(value));
                                  }
                                }
                              },
                              {
                                name: 'revenue',
                                options: {
                                  customHeadRender: ({ index, ...column }, sortColumn) => {
                                    return getHeaderLabel(index, column, sortColumn, formatRevenue.format(revenueTotal))
                                  },
                                }
                              },
                              {
                                name: 'viewability',
                                options: {
                                  customHeadRender: ({ index, ...column }, sortColumn) => {
                                    return getHeaderLabel(index, column, sortColumn, (viewabilityTotal / totalActive).toFixed(2))
                                  },
                                  customBodyRender: (value) => {
                                    const floatValue = parseFloat(value);
                                    return (floatValue >= 80 ? <div style={{ backgroundColor: "#dff0d8", fontWeight: "bold" }}>{value}</div> :
                                      floatValue >= 60 && floatValue < 80 ? <div style={{ backgroundColor: "#fcf8e3", fontWeight: "bold" }}>{value}</div> :
                                        floatValue < 60 ? <div style={{ backgroundColor: "#f2dede", fontWeight: "bold" }}>{value}</div> : <div>{value}</div>);
                                  }
                                }
                              }
                            ]}
                            options={{
                              customToolbarSelect: () => { },
                              rowsPerPage: 100,
                              selectableRows: 'none'

                            }}
                          />
                        </Grid>
                      </Grid>
                    )}
              </Grid>
            </Grid>

          </>)}
      </ThemeProvider>
    </>
  );
}